import {
  PERSONALTASKLIST_FETCHING,
  PERSONALTASKLIST_SUCCESS,
  PERSONALTASKLIST_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PERSONALTASKLIST_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PERSONALTASKLIST_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PERSONALTASKLIST_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
